const SPDay = [
    {id: "20", value: "20日"},    
    {id: "60", value: "60日"},
    {id: "120", value: "120日"},
    {id: "240", value: "240日"},   
  ];  
  
  export default SPDay  